import Vue from 'vue';
import Vuex from 'vuex';

import Sample from '@/app/sample';

// Components
import Breadcrumb from '@/components/breadcrumb';
import Year from '@/components/calendar/year';
import Month from '@/components/calendar/month';
import Week from '@/components/calendar/week';

// Pages/app
import Agenda from '@/app/agenda';
import Inbox from '@/app/inbox';
import LeavingMonitor from '@/app/leaving-monitor';
import Gallery from '@/app/gallery';
import Album from '@/app/gallery/album';
import Medicine from '@/app/medicine';
import MealMenu from '@/app/meal-menu';
import Simulator from '@/app/simulator/simulator';
import LessonPlanning from '@/app/lesson-planning';
import Evaluation from '@/app/evaluation';

// Domains
import Logged from '@/domains/logged';
import Class from '@/domains/school/class-list';
import Theme from '@/domains/school/theme';
import Student from '@/domains/student';
import Homework from '@/domains/homework';
import ClassGrade from '@/domains/school/class-grade';
import ClassLevel from '@/domains/school/class-level';

// Default
import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

// https://vuex.vuejs.org/en/
Vue.use(Vuex);

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
	strict: true,
	modules: {
		Sample,
		Breadcrumb,
		Year,
		Month,
		Week,
		Agenda,
		Inbox,
		LeavingMonitor,
		Medicine,
		MealMenu,
		Gallery,
		Album,
		Logged,
		Theme,
		Class,
		Student,
		Homework,
		ClassGrade,
		ClassLevel,
		LessonPlanning,
		Evaluation,
		Simulator
	}
});



// WEBPACK FOOTER //
// ./sources/store/index.js